document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".atha-hero-slider").forEach(initHero);

});

function initHero(slider) {

  const track = slider.querySelector(".atha-hero-track");
  const prev = slider.querySelector(".atha-hero-prev");
  const next = slider.querySelector(".atha-hero-next");
  const dots = [...slider.querySelectorAll(".atha-hero-dot")];

  if (!track) return;

  let slides = [...track.querySelectorAll(".atha-hero-slide")];

  if (slides.length <= 1) return;

  /* ===============================
     CREATE CLONES
  =============================== */

  const firstClone = slides[0].cloneNode(true);
  const lastClone = slides[slides.length - 1].cloneNode(true);

  firstClone.classList.add("clone");
  lastClone.classList.add("clone");

  track.insertBefore(lastClone, slides[0]);
  track.appendChild(firstClone);

  slides = [...track.querySelectorAll(".atha-hero-slide")];

  let current = 1;
  let allowShift = true;
  let auto;

  track.style.transition = "none";
  track.style.transform = `translateX(-100%)`;

  requestAnimationFrame(() => {

    requestAnimationFrame(() => {

      track.style.transition = "transform .55s ease";

    });

  });

  function updateDots() {

    let real = current - 1;

    if (real < 0)
      real = dots.length - 1;

    if (real >= dots.length)
      real = 0;

    dots.forEach((dot, i) => {

      dot.classList.toggle("active", i === real);

    });

  }

  function slideTo(index) {

    if (!allowShift) return;

    allowShift = false;

    current = index;

    track.style.transform =
      `translateX(-${current * 100}%)`;

  }

  function nextSlide() {

    slideTo(current + 1);

  }

  function prevSlide() {

    slideTo(current - 1);

  }
track.addEventListener("transitionend", () => {

    if (current === slides.length - 1) {

        track.style.transition = "none";

        current = 1;

        track.style.transform = `translateX(-${current * 100}%)`;

        // FORCE REFLOW
        track.offsetHeight;

        track.style.transition = "transform .55s ease";

    }

    else if (current === 0) {

        track.style.transition = "none";

        current = slides.length - 2;

        track.style.transform = `translateX(-${current * 100}%)`;

        // FORCE REFLOW
        track.offsetHeight;

        track.style.transition = "transform .55s ease";

    }

    allowShift = true;

    updateDots();

});

    /* ===============================
     AUTOPLAY
  =============================== */

  function startAuto() {

    stopAuto();

    auto = setInterval(() => {

      nextSlide();

    }, 5000);

  }

  function stopAuto() {

    clearInterval(auto);

  }

  startAuto();

  slider.addEventListener("mouseenter", stopAuto);

  slider.addEventListener("mouseleave", startAuto);

  /* ===============================
     ARROWS
  =============================== */

  next?.addEventListener("click", () => {

    nextSlide();

    startAuto();

  });

  prev?.addEventListener("click", () => {

    prevSlide();

    startAuto();

  });

  /* ===============================
     DOTS
  =============================== */

  dots.forEach((dot, i) => {

    dot.addEventListener("click", () => {

      slideTo(i + 1);

      startAuto();

    });

  });

  /* ===============================
     TOUCH SWIPE
  =============================== */

  let touchStart = 0;
  let touchEnd = 0;

  slider.addEventListener("touchstart", (e) => {

    touchStart = e.touches[0].clientX;

    stopAuto();

  }, { passive: true });

  slider.addEventListener("touchmove", (e) => {

    touchEnd = e.touches[0].clientX;

  }, { passive: true });

  slider.addEventListener("touchend", () => {

    const diff = touchStart - touchEnd;

    if (Math.abs(diff) > 40) {

      if (diff > 0) {

        nextSlide();

      } else {

        prevSlide();

      }

    }

    startAuto();

  });

  /* ===============================
   MOUSE DRAG
=============================== */

let isDragging = false;
let startPos = 0;
let currentTranslate = 0;
let previousTranslate = 0;
let animationID;

function animation() {

    if (isDragging) {

        track.style.transition = "none";
        track.style.transform = `translateX(calc(-${current * 100}% + ${currentTranslate}px))`;

        animationID = requestAnimationFrame(animation);

    }

}

slider.addEventListener("mousedown", (e) => {

    isDragging = true;
    startPos = e.clientX;
    currentTranslate = 0;

    stopAuto();

    animationID = requestAnimationFrame(animation);

});

window.addEventListener("mousemove", (e) => {

    if (!isDragging) return;

    currentTranslate = e.clientX - startPos;

});

window.addEventListener("mouseup", () => {

    if (!isDragging) return;

    cancelAnimationFrame(animationID);

    isDragging = false;

    track.style.transition = "transform .55s ease";

    if (currentTranslate < -80) {

        nextSlide();

    }

    else if (currentTranslate > 80) {

        prevSlide();

    }

    else {

        track.style.transform = `translateX(-${current * 100}%)`;

    }

    startAuto();

});

    /* ===============================
     KEYBOARD
  =============================== */

  slider.setAttribute("tabindex", "0");

  slider.addEventListener("keydown", (e) => {

    if (e.key === "ArrowRight") {

      nextSlide();

      startAuto();

    }

    if (e.key === "ArrowLeft") {

      prevSlide();

      startAuto();

    }

  });

  /* ===============================
     RESIZE
  =============================== */

  window.addEventListener("resize", () => {

    track.style.transition = "none";

    track.style.transform =
      `translateX(-${current * 100}%)`;

    requestAnimationFrame(() => {

      track.style.transition =
        "transform .55s ease";

    });

  });

  /* ===============================
     INITIAL STATE
  =============================== */

  updateDots();

  track.style.transform =
    `translateX(-${current * 100}%)`;

  startAuto();




  /* ===============================
   PAGE VISIBILITY
=============================== */

document.addEventListener("visibilitychange", () => {

    if (document.hidden) {

        stopAuto();

    } else {

        startAuto();

    }

});


}